window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      console.log('_onSelectChange!');
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productAvailability: '[data-product-availability]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',

    // swatches
    swatch: '.swatch',
    swatchInput: '.swatch :radio',
    swatchElement: '.swatch-element',
    swatchSelected: '.selected-swatch',
    swatchSelectText: '.selected-swatch-text',
    productSlideshow: '.product-slideshow',
    productImages: '.product-slideshow .product-image',
    slideshowItem: '.swiper-slide',
    bulletPaging: 'ul.bullets',
    bulletListItem: 'ul.bullets li',
    bulletLinks: 'ul.bullets a'
  };

  var data = {
    variantIDs: 'data-variants'
  }

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    var breakpoint = window.matchMedia( '(min-width:750px)' );

    if (breakpoint.matches == true) {
      var stickyContent = new StickySidebar('.sticky-wrapper', {
        containerSelector: '#product-content',
        innerWrapperSelector: '.sidebar__inner',
        topSpacing: 40,
        bottomSpacing: 60
      });

      $(document).on('lazyloaded', function(e){
        stickyContent.updateSticky();
      });
    }

    $(selectors.swatchSelectText, this.$container).before('<span class="swatch-colon">: </span>');

    var $mainOptions = $(selectors.swatch, this.$container);

    $mainOptions.each(function() {
      var selectedSwatchInput = $(this).find(':radio:checked').eq(0),
        selectedSwatch = $(selectedSwatchInput).val();
      _triggerSelectedSwatch(selectedSwatchInput, selectedSwatch);
    });

    $(selectors.swatchInput).click(function(e) {
      var selectedSwatch = $(this).val();
      _triggerSelectedSwatch(this, selectedSwatch);
    });

    function _triggerSelectedSwatch(el, selectedSwatch) {
      var optionNum = $(el).attr('name').replace('option-', ''),
        $swatchEl = $(selectors.swatch+'[data-option-index='+optionNum+']').add('[data-option-index='+optionNum+']', $(selectors.stickyForm)),
        $swatchText = $swatchEl.find(selectors.swatchSelectText);
      $swatchText.html(selectedSwatch);
    }

    this._productSlideshowInit();
    this._videoEmbedInit();
    this._popupInit();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    _productSlideshowInit: function() {

      if (!$(selectors.productSlideshow).length) { return; }

      var breakpoint = window.matchMedia( '(min-width:750px)' );

      if (breakpoint.matches == true) {

        let _this = this;
        let productImages = $(selectors.productImages);
        let windowTrigger = window.innerHeight / 4;
        let visibleImg;
        
        imageScrollInit();

        function imageScrollInit() {
          if (window.pageYOffset > windowTrigger) {
            productImages.each(function() {
              var visible = _this._imageVisibilityTrigger(this, windowTrigger);

              if (visible) {
                visibleImg = $(this).get(0);
                return false;
              }
            });  
          } else {
            visibleImg = productImages.get(0);
          }

          let id = 0;

          if (visibleImg) {
            id = (visibleImg).getAttribute('id').replace('image-', '');          
          }

          setBulletActive(id);
        }

        function setBulletActive(imgId) {
          $(selectors.bulletListItem).removeClass('active');

          $(selectors.bulletLinks).filter('[data-image-id='+imgId+']').parent('li').addClass('active');
        }
        
        document.addEventListener('scroll', function() {
          let listener = false;

          if (!listener) {
            setTimeout(function() {
              imageScrollInit();
              listener = true;
            }, 200);  
          }
        });

      } else {
        var productSwiper = new Swiper(selectors.productSlideshow, {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
        });
      }
    },

    _imageVisibilityTrigger: function(el, trigger) {
      const rect = el.getBoundingClientRect();
      return (
          rect.top < trigger &&
          rect.top > 0
      );
    },

    _videoEmbedInit: function() {
      var selectors = {
        videoWrap: '.product-video',
        colorboxLink: 'a.colorbox'
      };
      
      if (!$(selectors.colorboxLink).length) { return; }
      
      $(selectors.videoWrap).find(selectors.colorboxLink).colorbox({
        iframe: true
      });
    },

    _popupInit: function() {
      var selectors = {
        popup: '[data-popup]'
      };

      if (!$(selectors.popup).length) { return; }

      $(selectors.popup).each(function() {
        var $el = $(this),
          popupData = $el.data('popup'),
          $popupParent = $el.closest('.'+popupData);

        $el.addClass('init');

        $popupParent.find('a[href="#popup"]').click(function(e) {
          e.preventDefault();
          $el.toggleClass('visible');
        });

        $el.find('button.close').add($el).click(function(e) {
          e.preventDefault();
          $el.removeClass('visible');
        });

        $el.find('.popup-modal').click(function(e) {
          e.stopPropagation();
        });
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      if (variant.compare_at_price > variant.price) {
        $(selectors.productPrice, this.$container)
          .html('<span class="sale-price">'+slate.Currency.formatMoney(variant.price, theme.moneyFormat)+'</span>');

        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      if (variant.available) {
        $(selectors.productAvailability, this.$container).html('');
      } else {
        $(selectors.productAvailability, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);

      var breakpoint = window.matchMedia( '(min-width:750px)' );

      if (breakpoint.matches == true) {
        document.querySelectorAll(selectors.bulletLinks).forEach(function(el) { 
          if (el.getAttribute(data.variantIDs) && el.getAttribute(data.variantIDs).indexOf(variant.id.toString()) > -1 ) { 
            el.click();
          } 
        });
      } else {
        const productSwiper = document.querySelector(selectors.productSlideshow).swiper;

        document.querySelectorAll(selectors.productImages).forEach(function(el, index) {
          if (el.getAttribute(data.variantIDs).indexOf(variant.id.toString()) > -1) {
            console.log('go to slide index = '+index);
            productSwiper.slideTo(index);
          }
        });
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();
/**
 * Index Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Index template.
 *
   * @namespace index
 */

theme.Collection = (function() {

  var selectors = {
    collFilters: '.coll-filter',
    filterItem: '.filter-item',
    filterBtn: 'button.filter-button',
    filterList: 'ul.filter-list',
    faqSection: '.faq-section',
    faq: '.faq',
    question: 'button.question',
    answer: '.answer'
  };

  function Collection(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    if (!$(selectors.collFilters, this.$container).length) { return; }

    $(selectors.filterBtn).click(function(e) {
      e.preventDefault();
      if (!$(this).parent().hasClass('show-list')) {
        $(selectors.filterItem).removeClass('show-list');
        $(this).parent().addClass('show-list');  
      } else {
        $(this).parent().removeClass('show-list');  
      }
    });

    $(selectors.filterBtn).on('blur', function() {
      $(this).parent().removeClass('show-list'); 
    });
  }

  Collection.prototype = $.extend({}, Collection.prototype, {});

  return Collection;
})();


/**
 * Index Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Index template.
 *
   * @namespace index
 */

theme.Index = (function() {

  var selectors = {
    
  };

  /**
   * Index section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Index(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');
    
  }

  Index.prototype = $.extend({}, Index.prototype, {});

  return Index;
})();


theme.Marquee = (function() {
  var selectors = {
    marquee: '.marquee'
  };

  function Marquee(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    $(selectors.marquee, this.$container).marquee();
  }

  Marquee.prototype = $.extend({}, Marquee.prototype, {});

  return Marquee;
})();


theme.ProductSlideshow = (function() {
  var selectors = {
    textSlideshow: '.text-swiper',
    imageSlideshow: '.image-swiper'
  };

  function ProductSlideshow(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    var textSwiper = new Swiper(selectors.textSlideshow, {
      speed: 600,
      effect: 'fade',
      autoplay: {
        delay: 5000
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true
    });

    var imageSwiper = new Swiper(selectors.imageSlideshow, {
      speed: 600,
      loop: true
    });

    textSwiper.controller.control = imageSwiper;
    imageSwiper.controller.control = textSwiper;
  }

  ProductSlideshow.prototype = $.extend({}, ProductSlideshow.prototype, {});

  return ProductSlideshow;
})();

theme.SubscriptionsSlideshow = (function() {
  var selectors = {
    imageSlideshow: '.subscription-image-swiper'
  };

  function SubscriptionsSlideshow(container) {
    this.$container = $(container);
    console.log(this.$container);

    var sectionId = this.$container.attr('data-section-id');

    var swiper = new Swiper(selectors.imageSlideshow, {
      speed: 600,
      effect: 'fade',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true
    });
  }

  SubscriptionsSlideshow.prototype = $.extend({}, SubscriptionsSlideshow.prototype, {});

  return SubscriptionsSlideshow;
})();


theme.FeaturedProducts = (function() {

  function FeaturedProducts(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    theme.HelperFunctions.tabToggle(this.$container);
  }

  FeaturedProducts.prototype = $.extend({}, FeaturedProducts.prototype, {});

  return FeaturedProducts;

})();

theme.ShopInfo = (function() {

  function ShopInfo(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    theme.HelperFunctions.tabToggle(this.$container);
  }

  ShopInfo.prototype = $.extend({}, ShopInfo.prototype, {});

  return ShopInfo;

})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



theme.HelperFunctions = (function() {
  AOS.init();
  _initQtySelect();
  _initAjaxBtns();

  function _initQtySelect() {
    // Quantity Selector
    var $quantitySelect = $('.quantity-select');

    $quantitySelect.each(function() {
      var $el = $(this);
      var $quantityDown = $el.find('.adjust-minus');
      var $quantityUp = $el.find('.adjust-plus');
      var $quantity = $el.find('input.quantity');

      var quantity = $quantity.val();

      $quantityDown.on('click', function(e) {
        quantity = $quantity.val();
        if (quantity > 1) {
          quantity--;
          $quantity.val(quantity).trigger('change');
        }
        e.preventDefault();
      });

      $quantityUp.on('click', function(e) {
        quantity = $quantity.val();
        quantity++;
        $quantity.val(quantity).trigger('change');

        e.preventDefault();
      });

      $quantity.closest('form').find('input[type=submit][name=update]').hide();

      $quantity.on('change', function () {
        $(this).closest('form').find('input[type=submit][name=update]').trigger('click');
      });
    });
  }

  function _initAjaxBtns() {
    var btnSelector = '[data-ajax-add-to-cart]';

    if (!$(btnSelector).length) { return; }

    $(btnSelector).click(function(e) {
      e.preventDefault();

      var id = $(this).data('product-id'),
        $btn = $(this);

      $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: 'quantity=1&id=' + id,
          success: function(res) {
            $btn.html('Added!').delay(800, function() {
              $btn.fadeOut();
            });
            console.log($btn);
            _updateCartCount();
          },
          error: function(res) {
            console.log(res);
          }
       });
    })
  }

  function _updateCartCount() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(res) {
        var count = res.item_count;

        $('#cart-count-link').html(count);
      }
    })
  }

  function tabToggle($container) {
    var selectors = {
      wrapper: '.toggle-wrap',
      button: '.toggle-paging button',
      item: '.toggle-item'
    };
    var data = {
      toggle: 'data-toggle'
    };
    var classes = {
      init: 'toggle-init',
      active: 'active'
    };

    if (!$('.toggle-wrap', $container).length) { return; }

    _init();

    $(selectors.button, $container).click(function(e) {
      e.preventDefault();

      var toggleNew = $(this).attr(data.toggle);
      _toggleItems(toggleNew);
    });

    function _toggleItems(toggleNew) {
      var $items = $(selectors.item, $container).add(selectors.button, $container);

      $items.removeClass(classes.active);

      $items.filter('['+data.toggle+'="'+toggleNew+'"]').addClass(classes.active);
    }

    function _init() {
      $container.addClass(classes.init);

      var toggleNew = $(selectors.button, $container).first().attr(data.toggle);
      _toggleItems(toggleNew);
    }

  }

  function a11yDrawer() {
    var selectors = {
      drawerSection: '.a11y-drawer',
      btn: 'button.drawer-title',
      content: '.drawer-content'
    };
    // build accessible accordion w/van11y 
    if ($(selectors.drawerSection).length > 0) {
      var $drawerSection = $(selectors.drawerSection);

      $drawerSection.each(function() {
        $(this).find(selectors.btn).attr('aria-expanded', 'false');
        $(this).find(selectors.content).attr('aria-hidden', 'true');

          $(this).find(selectors.btn).click(function() {  
          if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr({
              'aria-expanded': 'true',
              'aria-selected': 'true'
            });
            $(this).siblings(selectors.content).removeAttr('aria-hidden');
          } else {
            $(this).attr('aria-expanded', 'false').removeAttr(
              'aria-selected');
            $(this).siblings(selectors.content).attr('aria-hidden', 'true');
          }
        });
      });
    }
  }

  a11yDrawer();

  return {
    tabToggle: tabToggle,
    a11yDrawer: a11yDrawer
  };
})();

theme.Header = (function() {
  var selectors = {
    header: '#site-header',
    dropdownItem: 'li.has-special-dropdown',
    searchTrigger: '#search-trigger',
    searchOverlay: '#search-overlay',
    searchInput: '#search-form input#Search',
    searchClose: '#search-form .close',
    menuLink: '.icon-menu',
    dropdownTrigger: '.dropdown-trigger',
    dropdown: '.dropdown',
    parentLi: '.has-children'
  };
  var classes = {
    showSearch: 'show-search-bar',
    bodyNavOpen: 'mobile-nav-open',
    navOpen: 'opened',
    dropdownOpen: 'show-dropdown',
    bodyHeadroom: 'headroom-init'
  }

  var $body = $('body');

  $(selectors.header).find(selectors.dropdownItem).each(function() {
    $(this).mouseover(function() {
      $(selectors.header).addClass('show-dropdown');
    });
    $(this).mouseout(function() {
      $(selectors.header).removeClass('show-dropdown');
    });
  });

  $(selectors.searchTrigger).click(function(e) {
    e.preventDefault();

    $(selectors.searchInput).focus();

    $body.addClass(classes.showSearch).on('keyup', function(e) {
      if (e.key === "Escape") {
        $body.removeClass(classes.showSearch);
      }
    });
  });

  $(selectors.searchOverlay).add(selectors.SearchClose).click(function() {
    $body.removeClass(classes.showSearch).off('keyup');
  });

  if ($(window).outerWidth() < 1010) {
    $(selectors.menuLink).click(function(e) {
      e.preventDefault();

      $body.toggleClass(classes.bodyNavOpen);
      $(this).toggleClass(classes.navOpen);
    });

    $(selectors.dropdownTrigger).click(function(e) {
      e.preventDefault();
      $(this).siblings(selectors.dropdown).slideToggle();
    });

    $(selectors.dropdown).hide();
  } else {
    $(selectors.dropdownTrigger).click(function(e) {
      e.preventDefault();

      $(this).closest(selectors.parentLi).toggleClass(classes.dropdownOpen);
    });
  }

  // Headroom
  var header = document.querySelector(selectors.header);

  var headroom = new Headroom(header, {
    offset: 200,
    onPin: function() {
      $body.addClass('headroom-is-pinned');
    },
    onUnpin: function() {
      $body.removeClass('headroom-is-pinned');
    }
  });
  headroom.init();
  $body.addClass(classes.bodyHeadroom);
})();

theme.ClassesTemplate = (function() {
  var selectors = {
    trigger: '[data-load-more-trigger]',
    wrapper: '[data-load-more-wrap]',
    newWrapper: '[data-load-more-new-wrap]',
    venueSlideshow: '.venue-swiper'
  };
  var classes = {
  };
  var data = {
    url: 'load-more-url',
    pages: 'load-more-pages'
  }

  function ClassesTemplate(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    this._loadMoreInit();
    this._venueSlideshowInit();
  }

  ClassesTemplate.prototype = $.extend({}, ClassesTemplate.prototype, {
    _venueSlideshowInit: function() {
      if (!$(selectors.venueSlideshow).length) { return; }

      var swiper = new Swiper(selectors.venueSlideshow, {
        slidesPerView: 1,
        spaceBetween: 20,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      });
    },
    _loadMoreInit: function() {
      console.log($(selectors.trigger, this.$container)); 

      $(selectors.trigger, this.$container)
        .addClass('load-more-init')
        .click(function(e) {
          e.preventDefault();
          var nextUrl = $(this).data(data.url),
            numOfPages = $(this).data(data.pages),
            pageIndex = nextUrl.indexOf('page='),
            nextPage = parseInt(nextUrl.slice(pageIndex+5)) + 1,
            content = nextUrl + ' ' + selectors.wrapper + ' > *';

          console.log('nextUrl = '+nextUrl);

          if (nextUrl.length < 0) { return; }

          $(selectors.wrapper)
            .after('<div data-load-more-new-wrap></div>')
            .removeAttr('data-load-more-wrap');

          $(selectors.newWrapper)
            .load(content)
            .removeAttr('data-load-more-new-wrap')
            .attr('data-load-more-wrap', '');

          if (nextPage < numOfPages) {
            var newNextUrl = '/pages/classes-events?page='+nextPage;
            console.log(newNextUrl);
            $(this).data(data.url, newNextUrl);
          } else {
            $(this).attr('disabled', true).fadeOut();
          }
        });
    }
  });

  return ClassesTemplate;
})();

$(document).ready(function() {
  var sections = new slate.Sections();
  // Templates
  sections.register('product', theme.Product);
  sections.register('collection', theme.Collection);
  sections.register('classes-template', theme.ClassesTemplate);

  // Index sections
  sections.register('marquee', theme.Marquee);
  sections.register('hero-banner', theme.HeroBanner);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('mint-instagram-feed', theme.InstagramFeed);
  sections.register('product-slideshow', theme.ProductSlideshow);
  sections.register('subscriptions-slideshow', theme.SubscriptionsSlideshow);
  sections.register('shop-info', theme.ShopInfo);
  sections.register('text-three-images', theme.TextThreeImages);
  
  // Global sections
  sections.register('header-section', theme.Header);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
